<sm-title-bar pageTitle="Membership Booking" [back]="true"></sm-title-bar>
<div
  class="member_details_view"
  *ngIf="!loader && membershipBookingsData.length > 0"
>
  <div class="container">
    <div class="row">
      <div class="col-sm-8 mobile-pnloyet">
        <div class="salon_mei_section">
          <mat-card appearance="outlined">
            <div class="exert_opd">
              <div class="opert_section">
                <button
                  *ngIf="
                    isFuture != '1' &&
                    (isOwner || membershipBookingsData[0].session_status != 3)
                  "
                  mat-icon-button
                  [matMenuTriggerFor]="menu"
                  class="more-button"
                  aria-label="More options"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button
                    mat-menu-item
                    (click)="
                      changeAttendanceStatus(1, membershipBookingsData[0])
                    "
                    *ngIf="
                      membershipBookingsData[0].bookingStatus == 0 ||
                      membershipBookingsData[0].bookingStatus == null ||
                      membershipBookingsData[0].bookingStatus == 'null'
                    "
                  >
                    <mat-icon class="material-icons-outlined"
                      >check_circle</mat-icon
                    >
                    <span>Mark as present</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="assignJobForMember(membershipBookingsData[0])"
                    *ngIf="
                      membershipBookingsData[0].bookingStatus == 1 &&
                      membershipBookingsData[0].session_status != 3 &&
                      isOwner
                    "
                  >
                    <mat-icon class="material-icons-outlined"
                      >assignment_ind</mat-icon
                    >
                    <span>Assign job</span>
                  </button>
                  <button
                  [disabled]="!getAccessStatus()"
                    mat-menu-item
                    (click)="operationForMember(membershipBookingsData[0], 2)"
                    *ngIf="
                      membershipBookingsData[0].bookingStatus == 1 &&
                      membershipBookingsData[0].session_status != 3 &&
                      membershipBookingsData[0].session_status != 2
                    "
                  >
                  <!-- RESTRICTED -->
                    <mat-icon class="material-icons-outlined">timer</mat-icon>
                    <span>Start job</span>
                  </button>
                  <button
                  [disabled]="!getAccessStatus()"
                    mat-menu-item
                    (click)="operationForMember(membershipBookingsData[0], 3)"
                    *ngIf="
                      membershipBookingsData[0].bookingStatus == 1 &&
                      membershipBookingsData[0].session_status != 3
                    "
                  >
                  <!-- RESTRICTED -->
                    <mat-icon class="material-icons-outlined"
                      >task_alt</mat-icon
                    >
                    <span>Job done</span>
                  </button>
                  <button
                  [disabled]="!getAccessStatus()"
                    mat-menu-item
                    (click)="updateProgress()"
                    *ngIf="membershipBookingsData[0].bookingStatus == 1"
                  >
                  <mat-icon class="material-icons-outlined"
                      >assessment</mat-icon
                    >
                    <!-- RESTRICTED -->
                    <span>Update progress</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="
                      changeAttendanceStatus(0, membershipBookingsData[0])
                    "
                    *ngIf="
                      membershipBookingsData[0].bookingStatus == null ||
                      membershipBookingsData[0].bookingStatus == 'null'
                    "
                  >
                    <mat-icon class="material-icons-outlined">cancel</mat-icon>
                    <span>Mark as absent</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="opentorate(membershipBookingsData[0])"
                    *ngIf="membershipBookingsData[0].session_status == 3"
                  >
                    <mat-icon class="material-icons-outlined">share</mat-icon>
                    <span>Ask member to rate</span>
                  </button>
                  <button
                    mat-menu-item
                    *ngIf="
                      (membershipBookingsData[0].bookingStatus == 0 ||
                        membershipBookingsData[0].bookingStatus == 1) &&
                      (isOwner)
                    "
                    (click)="deleteAttendance(membershipBookingsData[0])"
                  >
                    <mat-icon class="material-icons-outlined">delete</mat-icon>
                    <span>Delete attendance</span>
                  </button>
                </mat-menu>
              </div>

              <div class="membership_booking_htht">
                <div class="salon_img_member">
                  <img
                  (click)="goviewdetails(membershipBookingsData[0])"
                    style="cursor: pointer;"
                    [src]="membershipBookingsData[0].member_thumb_image"
                    onerror="this.src='../../../../assets/images/user-avatar.svg'"
                    alt=""
                  />
                </div>

                <div class="hair_ct_heading">
                  <div class="rahul_headert">
                    <div class="membergt_heading">
                      <h4 class="h4_hyper" (click)="goviewdetails(membershipBookingsData[0])">{{ membershipBookingsData[0].customer_name }}</h4>
                      <p>
                        {{ membershipBookingsData[0].country_code }}
                        {{ membershipBookingsData[0].customer_phone }}
                      </p>
                      <p>{{ membershipBookingsData[0].gender | titlecase }}</p>
                    </div>
                    <!-- <h3>
            Status:
            <span class="status"  [class.cancelled]="(membershipBookingsData[0].bookingStatus == 0 )"
         [class.new-booking]="(membershipBookingsData[0].bookingStatus == 1 && !membershipBookingsData[0].session_status ) "
         [class.under-process]="(membershipBookingsData[0].bookingStatus == 1 && (membershipBookingsData[0].session_status ==  2 || membershipBookingsData[0].session_status ==  1)) "
         [class.completed]="(membershipBookingsData[0].bookingStatus == 1 && membershipBookingsData[0].session_status ==  3) ">{{membershipBookingsData[0].bookingStat}}</span>
    </h3> -->
                  </div>
                </div>
              </div>

              <div class="active_cardt">
                <!-- Status:  -->
                <p>
                  <span
                    class="member_bookign_status"
                    [class.cancelled_bg]="
                      membershipBookingsData[0].bookingStatus == 0
                    "
                    [class.new-booking_bg]="
                      membershipBookingsData[0].bookingStatus == 1 &&
                      !membershipBookingsData[0].session_status
                    "
                    [class.under-process_bg]="
                      membershipBookingsData[0].bookingStatus == 1 &&
                      (membershipBookingsData[0].session_status == 2 ||
                        membershipBookingsData[0].session_status == 1)
                    "
                    [class.completed_bg]="
                      membershipBookingsData[0].bookingStatus == 1 &&
                      membershipBookingsData[0].session_status == 3
                    "
                  ></span>

                  <span class="status" style="padding-left: 18px">{{
                    membershipBookingsData[0].bookingStat
                  }}</span>
                </p>
              </div>
            </div>
          </mat-card>
        </div>

        <div class="workout_timiing_open">
          <div class="booking_name_opop">
            <h1 style="margin-bottom: 5px">Slot info</h1>
          </div>
          <div class="slot_info_gt">
            <div class="solt_datef" style="margin-right: 12px">
              <mat-chip-list aria-label="service mode">
                <mat-chip selected color="primary">{{
                  membershipBookingsData[0].u_booking_date
                }}</mat-chip>
              </mat-chip-list>
            </div>
            <div class="solt_datef active_chip">
              <mat-chip-list aria-label="service mode">
                <mat-chip selected color="primary"
                  >{{ membershipBookingsData[0].bookingStartTime }} -
                  {{ membershipBookingsData[0].bookingEndTime }}</mat-chip
                >
              </mat-chip-list>
            </div>
          </div>
        </div>

        <!-- <div class="workout_timiing_open">
    <div class="booking_name_opop">
      <h1>Slot info</h1>
    </div>
    <div class="solt_datef" style=" margin-right: 12px;">
       <mat-chip-list aria-label="service mode">
      <mat-chip selected color="primary">{{membershipBookingsData[0].u_booking_date }}</mat-chip>
    </mat-chip-list>
    </div>
    <div class="solt_datef active_chip" style="padding-top: 0px;">
   
      <mat-chip-list aria-label="service mode">
      <mat-chip selected color="primary">{{membershipBookingsData[0].bookingStartTime}} - {{membershipBookingsData[0].bookingEndTime}}</mat-chip>
      </mat-chip-list>
      </div>
  </div> -->

        <div class="right_deatils_pp">
          <!-- Opted services -->
          <div class="sub_ser" *ngIf="membershipBookingsData[0].serviceInfo">
            <h3 class="sub_headingt">Opted service / package</h3>
            <div class="service_mode_chip">
              <div class="row">
                <div
                  class="col-sm-4"
                  *ngFor="let item of membershipBookingsData[0].serviceInfo"
                >
                  <div class="service_listh">
                    <div
                      class="bus_img"
                      *ngIf="item.img_url && item.img_url != 'null'"
                    >
                      <img
                        [src]="item.img_url"
                        onerror="this.src='../../../../assets/images/photo.png'"
                        alt=""
                      />
                    </div>
                    <div
                      class="placeholder_headingv"
                      *ngIf="!item.img_url || item.img_url == 'null'"
                    >
                      <p>{{ item.service_name.slice(0, 1).toUpperCase() }}</p>
                    </div>
                    <div class="bus_hjk">
                      <h4 class="prodcut_heading">
                        {{ item.service_name }} X {{ item.service_qty }}
                      </h4>
                      <p>{{ item.currency_symbol }}{{ item.rate }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Opted products -->
          <div
            class="sub_ser"
            *ngIf="membershipBookingsData[0].appointment_products"
          >
            <h3 class="sub_headingt">Opted products</h3>
            <div class="service_mode_chip">
              <div class="row">
                <div
                  class="col-sm-4"
                  *ngFor="
                    let item of membershipBookingsData[0].appointment_products
                  "
                >
                  <div class="service_listh">
                    <div
                      class="bus_img"
                      *ngIf="
                        item.product_img_url && item.product_img_url != 'null'
                      "
                    >
                      <img
                        [src]="item.product_img_url"
                        onerror="this.src='../../../../assets/images/photo.png'"
                        alt=""
                      />
                    </div>
                    <div
                      class="placeholder_headingv"
                      *ngIf="
                        !item.product_img_url || item.product_img_url == 'null'
                      "
                    >
                      <p>{{ item.product_name.slice(0, 1).toUpperCase() }}</p>
                    </div>
                    <div class="bus_hjk">
                      <h4 class="prodcut_heading">
                        {{ item.product_name }} X {{ item.item_qty }}
                      </h4>
                      <p>{{ item.currency_symbol }}{{ item.product_price }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Other items -->
          <div class="sub_ser" *ngIf="membershipBookingsData[0].custom_items">
            <h3 class="sub_headingt">Other items</h3>
            <div class="service_mode_chip">
              <div class="row">
                <div
                  class="col-sm-4"
                  *ngFor="let item of membershipBookingsData[0].custom_items"
                >
                  <div class="service_listh">
                    <div class="placeholder_headingv">
                      <p>{{ item.item_name.slice(0, 1).toUpperCase() }}</p>
                    </div>
                    <div class="bus_hjk">
                      <h4 class="prodcut_heading">
                        {{ item.item_name }} X {{ item.item_qty }}
                      </h4>
                      <p>{{ item.currency_symbol }}{{ item.item_price }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Notes -->
        <div class="workout_timiing_open">
          <div class="booking_name_opop">
            <h1 style="margin-bottom: 6px">Notes</h1>
          </div>
          <div class="member_paragr">
            <p>
              {{
                membershipBookingsData[0].member_notes &&
                membershipBookingsData[0].member_notes != "null"
                  ? membershipBookingsData[0].member_notes
                  : "No notes added."
              }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-sm-4 bookingrt">
        <!-- Trainer or Attendee -->
        <div
          class="trainer_start"
          *ngIf="
            membershipBookingsData[0].employeeName &&
            membershipBookingsData[0].employeeName != '' &&
            membershipBookingsData[0].employeeName != '---'
          "
        >
          <mat-card appearance="outlined">
            <div class="main_headingrt">
              <h1>Assigned to</h1>
            </div>
            <div class="trainer_list">
              <div class="trainer_img">
                <img
                  [src]="membershipBookingsData[0].image_thumb_url"
                  onerror="this.src='../../../../assets/images/user-avatar.svg'"
                  alt=""
                />
              </div>
              <div class="trainer_heading">
                <h3>{{ membershipBookingsData[0].employeeName }}</h3>
                <p>
                  {{ membershipBookingsData[0].employee_country_code }}
                  {{ membershipBookingsData[0].employee_phone }}
                </p>
              </div>
            </div>
          </mat-card>
        </div>
        <!--  -->
         <div
          class="trainer_start"
          *ngIf="
            membershipBookingsData[0].member_address &&
            membershipBookingsData[0].member_address != 'null' &&
            membershipBookingsData[0].member_address != '' && membershipBookingsData[0].bookingType == 0
          "
        >
          <mat-card
            appearance="outlined"
            class="addewsas"
            style="padding-bottom: 8px"
          >
            <div class="main_headingrt">
              <h1 style="margin-bottom: 2px">Member address</h1>
            </div>
            <p
              style="white-space: pre-line; margin-bottom: 5px; color: #888"
              *ngIf="
                membershipBookingsData[0].member_address.house_no ||
                membershipBookingsData[0].member_address.street_name
              "
            >
              <span *ngIf="membershipBookingsData[0].member_address.house_no"
                >{{ membershipBookingsData[0].member_address.house_no }},
              </span>
              <span *ngIf="membershipBookingsData[0].member_address.street_name">{{
                membershipBookingsData[0].member_address.street_name
              }}</span>
            </p>
            <p style="white-space: pre-line; margin-bottom: 5px; color: #888">
              {{ membershipBookingsData[0].member_address.city }},
              {{ membershipBookingsData[0].member_address.state }}, PIN/ZIP:
              {{ membershipBookingsData[0].member_address.zip }}
            </p>
            <p style="white-space: pre-line; margin-bottom: 5px; color: #888">
              {{ membershipBookingsData[0].member_address.address_line }}
            </p>
            <p
              style="white-space: pre-line; margin-bottom: 5px; color: #888"
              *ngIf="membershipBookingsData[0].member_address.landmark"
            >
              Landmark: {{ membershipBookingsData[0].member_address.landmark }}
            </p>
            <p
              *ngIf="membershipBookingsData[0].member_address.phone"
              style="white-space: pre-line; margin-bottom: 5px; color: #888"
            >
              Contact phone: {{ membershipBookingsData[0].member_address.country_code }}
              {{ membershipBookingsData[0].member_address.phone }}
            </p>

            <div
              class="flex_uner_flex"
              (click)="openGoogleMaps(membershipBookingsData[0].member_address)"
            >
              <div class="view_on_map_btn">
                <p>View on map</p>
              </div>
              <div class="arrow_map_icon">
                <mat-icon>arrow_forward</mat-icon>
              </div>
            </div>
          </mat-card>
        </div>
        <div
          class="trainer_start"
          *ngIf="
            membershipBookingsData[0].online_session_link &&
            membershipBookingsData[0].online_session_link != 'null' &&
            membershipBookingsData[0].online_session_link != '' && membershipBookingsData[0].bookingType == 2
          "
        >
         
          <mat-card
            appearance="outlined"
            class="addewsas"
          >
          
            <div class="main_headingrt">
              <h1 style="margin-bottom: 2px">Virtual session info</h1>
            </div>

            <p style="white-space: pre-line; margin-bottom: 5px; color: #888;margin-top: 10px;">
              Online meeting link:
              <a
                href="javascript:void(0)"
                style="color: #888"
                (click)="openLink(membershipBookingsData[0].online_session_link)"
                >{{ membershipBookingsData[0].online_session_link }}</a
              >
            </p>
            <p style="white-space: pre-line; margin-bottom: 5px; color: #888;word-wrap: break-word;margin-top: 10px;">
              App download:
              {{
                membershipBookingsData[0].online_session_app &&
                membershipBookingsData[0].online_session_app != "" &&
                membershipBookingsData[0].online_session_app != "null"
                  ? membershipBookingsData[0].online_session_app
                  : "---"
              }}
            </p>
            <p style="white-space: pre-line; margin-bottom: 5px; color: #888;margin-top: 10px;">
              Other session info:
              {{
                membershipBookingsData[0].online_session_notes &&
                membershipBookingsData[0].online_session_notes != "" &&
                membershipBookingsData[0].online_session_notes != "null"
                  ? membershipBookingsData[0].online_session_notes
                  : "---"
              }}
            </p>
          </mat-card>
        </div>
        <div class="workout_timiing_open newservicemode">
          <div class="membership_flexusing">
            <div class="solt_datef">
              <div class="booking_datey modecs">
                <h4 class="">Service mode</h4>
              </div>
              <mat-chip-list aria-label="service mode">
                <mat-chip selected color="primary">{{
                  membershipBookingsData[0].bType
                }}</mat-chip>
              </mat-chip-list>
            </div>

            <div class="solt_datef" style="padding-left: 20px">
              <div class="booking_datey modecs">
                <h4 class="">Billing type</h4>
              </div>
              <mat-chip-list aria-label="service mode">
                <mat-chip selected color="primary" class="billing_bg">{{
                  membershipBookingsData[0].bcycle
                }}</mat-chip>
              </mat-chip-list>
            </div>
          </div>
        </div>

        <div
          class="order_summary_section"
          style="margin-bottom: 20px"
          *ngIf="trackersData.length > 0"
        >
          <mat-card>
            <div class="booking_name_opop">
              <h1 style="font-weight: normal; margin-bottom: 20px">
                Fitness data
              </h1>
            </div>
            <div class="shop_flexc" *ngFor="let item of trackersData">
              <div class="clrt_heading">
                {{ item.tracking_item_name | titlecase }}
              </div>
              <div>
                {{
                  item.item_current_value
                    ? item.item_current_value
                    : item.tracking_logs
                    ? item.sortedLogs[0].tracking_item_value
                    : "---"
                }}
                {{
                  item.item_current_value || item.tracking_logs
                    ? item.measurement_unit
                    : ""
                }}
              </div>
            </div>

            <div class="shop_flex servi_border newflex">
              <div class="texhesdingt">
                Last update date:
                {{ latestDate ? (latestDate | date : "d MMM, y") : "---" }}
              </div>
              <div
              *ngIf="getAccessStatus()"
                class="progress-data_icon"
                style="
                  cursor: pointer;
                  display: flex;
                  cursor: pointer;
                  position: relative;
                  top: 2px;
                "
                (click)="updateProgress()"
              >
                <mat-icon>arrow_forward</mat-icon>
              </div>
            </div>
          </mat-card>
        </div>

        <div class="booking_detail_info">
          <p>{{ membershipBookingsData[0].entityInfo.name }}</p>
          <p class="address_frt">
            {{ membershipBookingsData[0].entityInfo.address }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
